import(/* webpackMode: "eager" */ "/vercel/path0/app/(global)/galerie/page.tsx");
